/**
 * Finish a sign-in made on the "sign in again to continue" notice: apply and store the
 * login, then resume the saved session. The session pointer was kept, so the
 * resume reads the same runtime session with the patient's answers.
 */
export const completeResumeSignIn = async ({
  authData,
  applyLogin,
  storeAuthentication,
  resume,
}) => {
  const { patient, accessToken, accessTokenExpiresIn, profile } = authData;
  await applyLogin({
    sessionId: null,
    accessToken,
    patient,
    prefillData: { patient, profile },
  });
  storeAuthentication({ accessToken, accessTokenExpiresIn, patient, profile });
  await resume();
};
